import { useCallback, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import Group from 'components/utils/Group'

const ResendLabelSlot = styled.span`
  display: inline-grid;
  justify-items: start;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  > * {
    grid-area: 1 / 1;
  }
`

const HiddenSizer = styled.span`
  visibility: hidden;
  pointer-events: none;
  user-select: none;
`

interface Props {
  countDown: number
  prompt: string
  resendLabel: string
  onResendSms: () => void
  onRequestCall: () => void
  disabled?: boolean
}

function OtpResendHelp(props: Props) {
  const {
    countDown,
    prompt,
    resendLabel,
    onResendSms,
    onRequestCall,
    disabled = false,
  } = props
  const intl = useIntl()
  const [hasResentSms, setHasResentSms] = useState(false)
  const [hasWaitedAfterResend, setHasWaitedAfterResend] = useState(false)
  if (hasResentSms && countDown > 0 && !hasWaitedAfterResend) {
    setHasWaitedAfterResend(true)
  }
  const linksDisabled = disabled || countDown > 0
  const showCallOption = hasResentSms && hasWaitedAfterResend && countDown === 0 && !disabled

  const callPrompt = useMemo(() => intl.formatMessage({
    id: 'q9EG-UUq3arq4BG0g-jg',
    defaultMessage: 'Still not receiving?',
  }), [intl])
  const callLabel = useMemo(() => intl.formatMessage({
    id: 'ivaxURGSSqmcDTB5IMoi',
    defaultMessage: 'Click to receive via phone call',
  }), [intl])

  const handleResendSms = useCallback(() => {
    setHasResentSms(true)
    onResendSms()
  }, [onResendSms])

  const countdownSizerLabel = countDown > 0 ? resendLabel.replace(/\d+/g, '00') : undefined

  return (
    <Group direction="vertical" gap={8} horizontalAlign="center">
      <Group direction="horizontal" gap={8}>
        <BodyText variant="medium">{prompt}</BodyText>
        <ResendLabelSlot>
          {countdownSizerLabel && (
            <HiddenSizer aria-hidden>
              <TextLink size="medium" wrap="no-wrap">{countdownSizerLabel}</TextLink>
            </HiddenSizer>
          )}
          <TextLink size="medium" wrap="no-wrap" onClick={handleResendSms} disabled={linksDisabled}>
            {resendLabel}
          </TextLink>
        </ResendLabelSlot>
      </Group>
      {showCallOption && (
        <Group direction="vertical" gap={4} horizontalAlign="center">
          <BodyText variant="medium">{callPrompt}</BodyText>
          <TextLink size="medium" onClick={onRequestCall}>
            {callLabel}
          </TextLink>
        </Group>
      )}
    </Group>
  )
}

export default OtpResendHelp
